import { render, staticRenderFns } from "./SubZone.vue?vue&type=template&id=3cc385eb&scoped=true"
import script from "./SubZone.vue?vue&type=script&lang=js"
export * from "./SubZone.vue?vue&type=script&lang=js"
import style0 from "./SubZone.vue?vue&type=style&index=0&id=3cc385eb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cc385eb",
  null
  
)

export default component.exports